import { type ReactNode } from 'react';

import { Button as AriaButton, ButtonProps as AriaButtonProps } from 'react-aria-components';

import { css } from '@allenai/varnish-panda-runtime/css';

import { cx } from '@/utils/cx';

import selectRecipe, { SelectRecipeProps } from '@/components/select/select.styles';
import focusRing from '@/components/shared/focusRing.styles';
import { FormInputContainer } from '../field/formInputContainer/FormInputContainer';

type SelectButtonProps = {
    label?: string;
    className?: string;
    children?: ReactNode;
} & AriaButtonProps &
    SelectRecipeProps;

const SelectButton = ({ className, ...rest }: SelectButtonProps) => {
    const [variantProps] = selectRecipe.splitVariantProps(rest);
    const recipeClassNames = selectRecipe(variantProps);
    return (
        <FormInputContainer
            Component={AriaButton}
            className={cx(css(focusRing), recipeClassNames.button, className)}
            {...rest}
            endControls={
                <ArrowDropDownIcon aria-hidden className={cx(recipeClassNames.arrowIcon)} />
            }
        />
    );
};

// maybe not needeed here
const ArrowDropDownIcon = ({ className }: { className: string }) => (
    <svg
        className={className}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g id="arrow_drop_down">
            <path id="Vector" d="M7 9.5L12 14.5L17 9.5H7Z" fill="currentColor" />
        </g>
    </svg>
);

export { SelectButton, SelectButton as default };
export type { SelectButtonProps };
